// extracted by mini-css-extract-plugin
export var numpadContainer = "_sh-1";
export var phoneButton = "_sh-0";